<template>
  <div>
    <vs-table :data="itemData">
      <template slot="header">
        <!-- <h3 v-if="this.$props.header">{{ header }}</h3> -->
      </template>
      <template slot="thead">
        <vs-th :key="ind" v-for="(col, ind) in columns" sort-key="col.field">{{col.name}}</vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td :key="i" v-for="(item, i) in columns" :data="tr[item.field]">{{tr[item.field]}}</vs-td>
          <template class="expand-user" slot="expand">
            <div class="con-expand-users w-full">
              <div class="con-btns-user flex items-center justify-between">
                <div class="con-userx flex items-center justify-start">
                  <vs-avatar
                    :badge="tr.id"
                    size="45px"
                    :src="`https://randomuser.me/api/portraits/women/${indextr}.jpg`"
                  />
                  <span>{{ tr.name }}</span>
                </div>
                <div class="flex">
                  <vs-button
                    type="border"
                    size="small"
                    icon-pack="feather"
                    icon="icon-edit"
                    class="mr-2"
                    @click="onEdit(tr)"
                  ></vs-button>
                  <vs-button
                    type="border"
                    size="small"
                    icon-pack="feather"
                    icon="icon-trash"
                    color="danger"
                    @click="onDelete(tr)"
                  ></vs-button>
                </div>
              </div>
              <vs-list>
                <vs-list-item icon-pack="feather" icon="icon-mail" :title="tr.email"></vs-list-item>
                <vs-list-item icon-pack="feather" icon="icon-globe" :title="tr.website"></vs-list-item>
              </vs-list>
            </div>
          </template>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
export default {
  name: "generic-table-expandable",
  props: {
    itemData: {},
    columns: {
      type: Array,
    }
  },
  methods: {
    onEdit(data) {
      console.log("edit", data);
    },
    onDelete(data) {
      console.log("delete", data);
    }
  },
  data() {
    return {};
  }
};
</script>

<style>
</style>